<button class="btn btn-default quick-accept-button" [attr.data-automation-id]="'work-item-accept-button'"
        (click)="accept.emit($event)">
  <span [attr.data-automation-id]="'button-label'">{{'bcWorkitemInteraction.acceptButtonLabel' | translate}}</span>
  <div class="shortcut">
    <span>SHIFT +</span>
    <svg-icon icon="enter-key"></svg-icon>
  </div>
</button>
